// oilPrices.js: historical crude oil price data for Driller.
//
// Annual average crude price, nominal USD/bbl ("money of the day").
//
// Sources:
//   1861-2025: Energy Institute Statistical Review of World Energy (2026 ed.;
//              formerly BP Statistical Review), via Our World in Data
//              (grapher "crude-oil-prices"), converted from USD/m3 at
//              1 m3 = 6.289811 bbl. Series composition:
//                1861-1944 US average, 1945-1983 Arabian Light (Ras Tanura),
//                1984-2025 Brent dated.
//   1859-1860: Not covered by EI/BP. These are commonly cited estimates
//              (~$20/bbl at Titusville late 1859, ~$9.59 avg 1860).
//   Monthly shock series: US EIA spot prices (Brent RBRTE, WTI Cushing RWTC),
//              monthly and daily, except 1973-74 and 1979-80, which are
//              reconstructed estimates (see PRICE_SHOCKS).
//
// All 1861-2025 annual values match the EI dataset after unit conversion
// (rounded to cents). Only 1859 and 1860 are estimates.

export const OIL_PRICES = {
  1859: 20.00, // est. (Drake era; Titusville ~$20/bbl, late 1859)
  1860: 9.59,  // est. (commonly cited 1860 average)
  1861: 0.49,
  1862: 1.05,
  1863: 3.15,
  1864: 8.06,
  1865: 6.59,
  1866: 3.74,
  1867: 2.41,
  1868: 3.63,
  1869: 3.64,
  1870: 3.86,
  1871: 4.34,
  1872: 3.64,
  1873: 1.83,
  1874: 1.17,
  1875: 1.35,
  1876: 2.56,
  1877: 2.42,
  1878: 1.19,
  1879: 0.86,
  1880: 0.95,
  1881: 0.86,
  1882: 0.78,
  1883: 1.00,
  1884: 0.84,
  1885: 0.88,
  1886: 0.71,
  1887: 0.67,
  1888: 0.88,
  1889: 0.94,
  1890: 0.87,
  1891: 0.67,
  1892: 0.56,
  1893: 0.64,
  1894: 0.84,
  1895: 1.36,
  1896: 1.18,
  1897: 0.79,
  1898: 0.91,
  1899: 1.29,
  1900: 1.19,
  1901: 0.96,
  1902: 0.80,
  1903: 0.94,
  1904: 0.86,
  1905: 0.62,
  1906: 0.73,
  1907: 0.72,
  1908: 0.72,
  1909: 0.70,
  1910: 0.61,
  1911: 0.61,
  1912: 0.74,
  1913: 0.95,
  1914: 0.81,
  1915: 0.64,
  1916: 1.10,
  1917: 1.56,
  1918: 1.98,
  1919: 2.01,
  1920: 3.07,
  1921: 1.73,
  1922: 1.61,
  1923: 1.34,
  1924: 1.43,
  1925: 1.68,
  1926: 1.88,
  1927: 1.30,
  1928: 1.17,
  1929: 1.27,
  1930: 1.19,
  1931: 0.65,
  1932: 0.87,
  1933: 0.67,
  1934: 1.00,
  1935: 0.97,
  1936: 1.09,
  1937: 1.18,
  1938: 1.13,
  1939: 1.02,
  1940: 1.02,
  1941: 1.14,
  1942: 1.19,
  1943: 1.20,
  1944: 1.21,
  1945: 1.05,
  1946: 1.12,
  1947: 1.90,
  1948: 1.99,
  1949: 1.78,
  1950: 1.71,
  1951: 1.71,
  1952: 1.71,
  1953: 1.93,
  1954: 1.93,
  1955: 1.93,
  1956: 1.93,
  1957: 1.90,
  1958: 2.08,
  1959: 2.08,
  1960: 1.90,
  1961: 1.80,
  1962: 1.80,
  1963: 1.80,
  1964: 1.80,
  1965: 1.80,
  1966: 1.80,
  1967: 1.80,
  1968: 1.80,
  1969: 1.80,
  1970: 1.80,
  1971: 2.24,
  1972: 2.48,
  1973: 3.29,
  1974: 11.58,
  1975: 11.53,
  1976: 12.80,
  1977: 13.92,
  1978: 14.02,
  1979: 31.61,
  1980: 36.83,
  1981: 35.93,
  1982: 32.97,
  1983: 29.55,
  1984: 28.78,
  1985: 27.56,
  1986: 14.43,
  1987: 18.44,
  1988: 14.92,
  1989: 18.23,
  1990: 23.73,
  1991: 20.00,
  1992: 19.32,
  1993: 16.97,
  1994: 15.82,
  1995: 17.02,
  1996: 20.67,
  1997: 19.09,
  1998: 12.72,
  1999: 17.97,
  2000: 28.50,
  2001: 24.44,
  2002: 25.02,
  2003: 28.83,
  2004: 38.26,
  2005: 54.52,
  2006: 65.14,
  2007: 72.39,
  2008: 97.26,
  2009: 61.67,
  2010: 79.50,
  2011: 111.26,
  2012: 111.67,
  2013: 108.66,
  2014: 98.95,
  2015: 52.39,
  2016: 43.73,
  2017: 54.19,
  2018: 71.31,
  2019: 64.21,
  2020: 41.84,
  2021: 70.91,
  2022: 101.32,
  2023: 82.64,
  2024: 80.76,
  2025: 69.10,
};

// Approximate price in constant 2024 US dollars per barrel (CPI-adjusted).
// Source: EI Statistical Review constant-dollar series (published in 2025 $
// via Our World in Data), rescaled to 2024 $ using the series' own 2024/2025
// ratio. 1859-1860 are estimated with the 1861 CPI multiplier (~36.7x).
export const OIL_PRICES_REAL_2024 = {
  1859: 740,   // est. from CPI ratio
  1860: 355,   // est. from CPI ratio
  1861: 18.00,
  1862: 33.79,
  1863: 81.21,
  1864: 166.05,
  1865: 130.95,
  1866: 76.25,
  1867: 52.73,
  1868: 82.65,
  1869: 86.46,
  1870: 95.74,
  1871: 115.01,
  1872: 96.46,
  1873: 49.50,
  1874: 33.25,
  1875: 39.81,
  1876: 77.31,
  1877: 74.81,
  1878: 38.61,
  1879: 27.90,
  1880: 30.08,
  1881: 27.23,
  1882: 24.70,
  1883: 32.31,
  1884: 27.71,
  1885: 29.63,
  1886: 24.43,
  1887: 22.80,
  1888: 29.95,
  1889: 33.06,
  1890: 30.95,
  1891: 23.83,
  1892: 19.92,
  1893: 23.03,
  1894: 31.60,
  1895: 52.42,
  1896: 45.48,
  1897: 30.83,
  1898: 35.51,
  1899: 50.34,
  1900: 45.87,
  1901: 36.55,
  1902: 30.10,
  1903: 34.58,
  1904: 31.27,
  1905: 22.81,
  1906: 26.27,
  1907: 24.80,
  1908: 25.33,
  1909: 24.90,
  1910: 20.78,
  1911: 20.78,
  1912: 24.70,
  1913: 31.05,
  1914: 26.23,
  1915: 20.62,
  1916: 32.44,
  1917: 38.18,
  1918: 41.25,
  1919: 36.45,
  1920: 48.07,
  1921: 30.32,
  1922: 30.12,
  1923: 24.63,
  1924: 26.24,
  1925: 30.07,
  1926: 33.33,
  1927: 23.48,
  1928: 21.43,
  1929: 23.26,
  1930: 22.36,
  1931: 13.39,
  1932: 19.98,
  1933: 16.22,
  1934: 23.43,
  1935: 22.17,
  1936: 24.68,
  1937: 25.78,
  1938: 25.16,
  1939: 23.04,
  1940: 22.81,
  1941: 24.28,
  1942: 22.91,
  1943: 21.76,
  1944: 21.57,
  1945: 18.30,
  1946: 17.98,
  1947: 26.68,
  1948: 25.93,
  1949: 23.42,
  1950: 22.28,
  1951: 20.65,
  1952: 20.21,
  1953: 22.64,
  1954: 22.53,
  1955: 22.61,
  1956: 22.27,
  1957: 21.22,
  1958: 22.61,
  1959: 22.38,
  1960: 20.15,
  1961: 18.89,
  1962: 18.67,
  1963: 18.44,
  1964: 18.21,
  1965: 17.92,
  1966: 17.40,
  1967: 16.93,
  1968: 16.23,
  1969: 15.39,
  1970: 14.54,
  1971: 17.35,
  1972: 18.60,
  1973: 23.24,
  1974: 73.67,
  1975: 67.21,
  1976: 70.56,
  1977: 72.05,
  1978: 67.42,
  1979: 136.63,
  1980: 140.20,
  1981: 123.96,
  1982: 107.18,
  1983: 93.07,
  1984: 86.91,
  1985: 80.37,
  1986: 41.30,
  1987: 50.90,
  1988: 39.59,
  1989: 46.12,
  1990: 56.96,
  1991: 46.07,
  1992: 43.19,
  1993: 36.85,
  1994: 33.48,
  1995: 35.03,
  1996: 41.34,
  1997: 37.31,
  1998: 24.47,
  1999: 33.84,
  2000: 51.91,
  2001: 43.31,
  2002: 43.64,
  2003: 49.16,
  2004: 63.55,
  2005: 87.58,
  2006: 101.37,
  2007: 109.52,
  2008: 141.70,
  2009: 90.18,
  2010: 114.36,
  2011: 155.16,
  2012: 152.58,
  2013: 146.32,
  2014: 131.11,
  2015: 69.34,
  2016: 57.16,
  2017: 69.35,
  2018: 89.09,
  2019: 78.79,
  2020: 50.71,
  2021: 82.09,
  2022: 108.61,
  2023: 85.08,
  2024: 80.76,
  2025: 67.09,
};

// ---------------------------------------------------------------------------
// HISTORICAL_EVENTS
// Notable oil-industry events, used for newspaper headlines and flavor.
//   month:       1-12 where known, otherwise null (game may pick a month).
//   priceEffect: short-term multiplier hint applied on top of the annual
//                average for a few weeks (1.0 = no effect, >1 spike, <1 drop).
//                These are flavor numbers, not historical measurements. The
//                big real moves are covered by PRICE_SHOCKS below.
//   category:    "discovery" | "technology" | "market" | "politics" | "disaster"
// ---------------------------------------------------------------------------
export const HISTORICAL_EVENTS = [
  { year: 1859, month: 8,  headline: "Drake Strikes Oil at Titusville: 69 Feet Down, Rock Oil Flows", priceEffect: 1.0, category: "discovery" },
  { year: 1861, month: 4,  headline: "Civil War Erupts; Oil Glut Drives Barrel to Mere Cents", priceEffect: 0.8, category: "politics" },
  { year: 1862, month: null, headline: "Federal Tax on Illuminants Fuels Kerosene Price Surge", priceEffect: 1.1, category: "politics" },
  { year: 1865, month: 10, headline: "Van Syckel Opens First Oil Pipeline: Teamsters Fume", priceEffect: 0.95, category: "technology" },
  { year: 1865, month: 1,  headline: "Pithole Boom! Wildcatters Flock to Overnight Oil Town", priceEffect: 0.9, category: "discovery" },
  { year: 1870, month: 1,  headline: "Rockefeller Incorporates Standard Oil Company of Ohio", priceEffect: 1.0, category: "market" },
  { year: 1872, month: 2,  headline: "South Improvement Scheme Exposed; Oil Region in Revolt", priceEffect: 1.05, category: "market" },
  { year: 1879, month: null, headline: "Bradford Field Floods Market; Crude Falls Below a Dollar", priceEffect: 0.85, category: "discovery" },
  { year: 1882, month: 1,  headline: "Standard Oil Trust Formed: 90% of US Refining Under One Roof", priceEffect: 1.0, category: "market" },
  { year: 1885, month: null, headline: "Lima-Indiana Field Opens; Sour 'Skunk Oil' Floods West", priceEffect: 0.95, category: "discovery" },
  { year: 1891, month: null, headline: "Baku Oil Rivals America; Nobel Brothers Ship Worldwide", priceEffect: 0.9, category: "market" },
  { year: 1901, month: 1,  headline: "Spindletop Gusher Roars at Beaumont: 100,000 Barrels a Day!", priceEffect: 0.7, category: "discovery" },
  { year: 1905, month: null, headline: "Glenn Pool Strike Makes Oklahoma the New Oil Frontier", priceEffect: 0.9, category: "discovery" },
  { year: 1908, month: 5,  headline: "Oil Found at Masjed Soleyman, Persia; Anglo-Persian Born", priceEffect: 1.0, category: "discovery" },
  { year: 1908, month: 10, headline: "Ford Unveils Model T; Gasoline Demand Set to Soar", priceEffect: 1.05, category: "market" },
  { year: 1909, month: 8,  headline: "Hughes Patents Two-Cone Rock Bit: Hard Rock No Longer a Barrier", priceEffect: 1.0, category: "technology" },
  { year: 1911, month: 5,  headline: "Supreme Court Orders Standard Oil Broken Into 34 Companies", priceEffect: 1.05, category: "politics" },
  { year: 1912, month: null, headline: "Royal Navy Switches From Coal to Oil; Fuel Becomes Strategic", priceEffect: 1.05, category: "politics" },
  { year: 1913, month: 1,  headline: "Burton Thermal Cracking Doubles Gasoline From Every Barrel", priceEffect: 1.0, category: "technology" },
  { year: 1914, month: 8,  headline: "War in Europe! Allies 'Float to Victory on a Wave of Oil'", priceEffect: 1.1, category: "politics" },
  { year: 1920, month: null, headline: "Gasoline Famine Fears Grip West Coast; Crude Hits $3", priceEffect: 1.15, category: "market" },
  { year: 1922, month: null, headline: "Cameron and Abercrombie Invent the Ram Blowout Preventer", priceEffect: 1.0, category: "technology" },
  { year: 1922, month: 12, headline: "Barroso Well Blows Wild in Venezuela: 100,000 bbl/day Gusher", priceEffect: 0.95, category: "discovery" },
  { year: 1924, month: 4,  headline: "Teapot Dome Scandal Rocks Washington Over Naval Oil Leases", priceEffect: 1.0, category: "politics" },
  { year: 1927, month: 10, headline: "Baba Gurgur Gusher in Iraq Ends Doubts of Mideast Riches", priceEffect: 0.9, category: "discovery" },
  { year: 1928, month: 9,  headline: "Red Line and Achnacarry Pacts: Majors Carve Up World Oil", priceEffect: 1.05, category: "market" },
  { year: 1930, month: 10, headline: "Dad Joiner Hits East Texas Giant; Crude Glut Looms", priceEffect: 0.85, category: "discovery" },
  { year: 1931, month: 8,  headline: "Martial Law in East Texas Oil Field as Crude Sells for a Dime", priceEffect: 0.6, category: "market" },
  { year: 1932, month: 5,  headline: "Oil Struck in Bahrain; Gulf Arabs Take Notice", priceEffect: 1.0, category: "discovery" },
  { year: 1935, month: 2,  headline: "Connally 'Hot Oil' Act Bans Illegal Interstate Crude", priceEffect: 1.1, category: "politics" },
  { year: 1938, month: 3,  headline: "Dammam No. 7 Strikes Oil: Saudi Arabia Enters the Game", priceEffect: 1.0, category: "discovery" },
  { year: 1938, month: 3,  headline: "Mexico Expropriates Foreign Oil Companies; PEMEX Created", priceEffect: 1.05, category: "politics" },
  { year: 1941, month: 8,  headline: "US Embargoes Oil to Japan; Pacific Tensions Soar", priceEffect: 1.05, category: "politics" },
  { year: 1943, month: 8,  headline: "'Big Inch' Pipeline Delivers Texas Crude to the East Coast", priceEffect: 1.0, category: "technology" },
  { year: 1947, month: 11, headline: "Kerr-McGee Drills First Well Out of Sight of Land in Gulf", priceEffect: 1.0, category: "technology" },
  { year: 1948, month: null, headline: "Ghawar Discovered: World's Largest Oil Field Confirmed", priceEffect: 0.95, category: "discovery" },
  { year: 1951, month: 5,  headline: "Iran Nationalizes Anglo-Iranian Oil; Abadan Shut", priceEffect: 1.1, category: "politics" },
  { year: 1956, month: 11, headline: "Suez Canal Closed! Tankers Diverted Around Africa", priceEffect: 1.2, category: "politics" },
  { year: 1959, month: 3,  headline: "Eisenhower Imposes Mandatory Oil Import Quotas", priceEffect: 1.0, category: "politics" },
  { year: 1960, month: 9,  headline: "Five Nations Form OPEC in Baghdad to Defend Oil Prices", priceEffect: 1.05, category: "politics" },
  { year: 1967, month: 6,  headline: "Six-Day War Brings Arab Oil Embargo; Suez Closed Again", priceEffect: 1.1, category: "politics" },
  { year: 1968, month: 3,  headline: "Prudhoe Bay Strike: North America's Biggest Field Found", priceEffect: 0.95, category: "discovery" },
  { year: 1969, month: 1,  headline: "Santa Barbara Platform Blowout Coats Beaches in Crude", priceEffect: 1.0, category: "disaster" },
  { year: 1969, month: 12, headline: "Phillips Finds Ekofisk: North Sea Oil Rush Begins", priceEffect: 1.0, category: "discovery" },
  { year: 1971, month: 2,  headline: "Tehran Agreement: OPEC Wins First Big Posted-Price Hike", priceEffect: 1.1, category: "market" },
  { year: 1973, month: 10, headline: "Arab Oil Embargo! OPEC Hikes Price 70%, Gas Lines Form", priceEffect: 1.0, category: "politics" },
  { year: 1974, month: 1,  headline: "Posted Price Quadruples to $11.65; World Economy Reels", priceEffect: 1.0, category: "market" },
  { year: 1975, month: 12, headline: "Congress Creates Strategic Petroleum Reserve", priceEffect: 1.0, category: "politics" },
  { year: 1977, month: 6,  headline: "Trans-Alaska Pipeline Opens; Prudhoe Crude Flows South", priceEffect: 0.98, category: "technology" },
  { year: 1979, month: 1,  headline: "Shah Flees Iran; Revolution Chokes Oil Exports", priceEffect: 1.0, category: "politics" },
  { year: 1979, month: 3,  headline: "Ixtoc I Blowout in Bay of Campeche Spews Oil for Months", priceEffect: 1.0, category: "disaster" },
  { year: 1980, month: 9,  headline: "Iran-Iraq War Erupts; Gulf Oil Facilities Ablaze", priceEffect: 1.0, category: "politics" },
  { year: 1981, month: 1,  headline: "Reagan Ends Oil Price Controls; Drilling Boom Peaks", priceEffect: 1.0, category: "politics" },
  { year: 1982, month: 2,  headline: "Ocean Ranger Rig Capsizes off Newfoundland; All 84 Lost", priceEffect: 1.0, category: "disaster" },
  { year: 1983, month: 3,  headline: "NYMEX Launches Crude Oil Futures; Paper Barrels Arrive", priceEffect: 1.0, category: "market" },
  { year: 1986, month: 1,  headline: "Saudis Open the Taps: Oil Crashes Below $10, Oil Patch Busts", priceEffect: 1.0, category: "market" },
  { year: 1988, month: 7,  headline: "Piper Alpha Explodes in North Sea; 167 Dead", priceEffect: 1.03, category: "disaster" },
  { year: 1989, month: 3,  headline: "Exxon Valdez Runs Aground; 11 Million Gallons Spilled", priceEffect: 1.02, category: "disaster" },
  { year: 1990, month: 8,  headline: "Iraq Invades Kuwait! Crude Doubles in Weeks", priceEffect: 1.0, category: "politics" },
  { year: 1991, month: 1,  headline: "Desert Storm Begins; Oil Plunges a Third in One Day", priceEffect: 1.0, category: "politics" },
  { year: 1991, month: 2,  headline: "Retreating Iraqis Torch 600 Kuwaiti Oil Wells", priceEffect: 1.0, category: "disaster" },
  { year: 1997, month: 11, headline: "OPEC Raises Output as Asian Crisis Hits Demand", priceEffect: 0.92, category: "market" },
  { year: 1998, month: 12, headline: "Brent Sinks to $9: Lowest in a Generation", priceEffect: 0.85, category: "market" },
  { year: 1998, month: 12, headline: "Exxon and Mobil Agree to $81 Billion Megamerger", priceEffect: 1.0, category: "market" },
  { year: 2001, month: 9,  headline: "Terror Attacks Rattle Markets; Oil Slumps on Demand Fears", priceEffect: 0.85, category: "politics" },
  { year: 2003, month: 3,  headline: "US Invades Iraq; Crude Spikes Then Falls on Swift Advance", priceEffect: 1.05, category: "politics" },
  { year: 2005, month: 8,  headline: "Hurricane Katrina Shuts Gulf Rigs and Refineries", priceEffect: 1.1, category: "disaster" },
  { year: 2008, month: 7,  headline: "Crude Hits Record $147 a Barrel!", priceEffect: 1.0, category: "market" },
  { year: 2008, month: 12, headline: "Financial Crisis Craters Demand; Oil Collapses to $33", priceEffect: 1.0, category: "market" },
  { year: 2010, month: 4,  headline: "Deepwater Horizon Explodes; 11 Dead, Gulf Spill Uncapped", priceEffect: 1.03, category: "disaster" },
  { year: 2010, month: 5,  headline: "Washington Halts Deepwater Drilling in Gulf of Mexico", priceEffect: 1.02, category: "politics" },
  { year: 2011, month: 2,  headline: "Libya in Civil War; Brent Tops $120", priceEffect: 1.08, category: "politics" },
  { year: 2012, month: null, headline: "Fracking Boom: North Dakota Bakken Output Soars", priceEffect: 1.0, category: "technology" },
  { year: 2014, month: 11, headline: "OPEC Refuses to Cut as Shale Glut Sinks Prices", priceEffect: 1.0, category: "market" },
  { year: 2015, month: 12, headline: "US Lifts 40-Year Ban on Crude Exports", priceEffect: 1.0, category: "politics" },
  { year: 2016, month: 1,  headline: "Brent Bottoms at $26; Rig Count Plunges", priceEffect: 0.8, category: "market" },
  { year: 2016, month: 12, headline: "OPEC+ Born: Saudis and Russia Agree Joint Cuts", priceEffect: 1.1, category: "market" },
  { year: 2019, month: 9,  headline: "Drone Strikes Hit Abqaiq; Half of Saudi Output Offline", priceEffect: 1.12, category: "politics" },
  { year: 2020, month: 3,  headline: "Pandemic and Saudi-Russia Price War Crush Crude", priceEffect: 1.0, category: "market" },
  { year: 2020, month: 4,  headline: "Oil Goes NEGATIVE: WTI Settles at Minus $37.63", priceEffect: 1.0, category: "market" },
  { year: 2022, month: 2,  headline: "Russia Invades Ukraine; Brent Rockets Past $130", priceEffect: 1.0, category: "politics" },
  { year: 2022, month: 12, headline: "EU Embargo and G7 Price Cap Hit Russian Seaborne Crude", priceEffect: 1.0, category: "politics" },
  { year: 2023, month: 10, headline: "Exxon Buys Pioneer for $60 Billion in Shale Megadeal", priceEffect: 1.0, category: "market" },
  { year: 2025, month: 4,  headline: "Tariff Shock and OPEC+ Output Hikes Send Oil to 4-Year Low", priceEffect: 0.92, category: "market" },
  { year: 2025, month: 6,  headline: "Israel-Iran Strikes Briefly Lift Brent Near $80", priceEffect: 1.07, category: "politics" },
];

// ---------------------------------------------------------------------------
// PRICE_SHOCKS
// Monthly average series for famous spikes/crashes, so the daily price can
// deviate from the flat annual average. monthly[] has one value per month
// from `start` through `end` inclusive (nominal USD/bbl).
//
//   benchmark: which series the monthly values come from.
//   verified:  true  = copied from EIA monthly spot data (Brent RBRTE / WTI RWTC)
//              false = reconstructed from official/posted price history; the
//                      shape is right, but treat individual months as estimates.
//   dailyExtremes: notable single-day prints for one-day news events.
//
// Note: the Brent monthly averages differ a bit from the annual values in
// OIL_PRICES (the Energy Institute series uses its own averaging), so the game
// should scale each shock to match the annual value, e.g.
// monthly[i] * OIL_PRICES[y] / mean(monthly for y).
// ---------------------------------------------------------------------------
export const PRICE_SHOCKS = [
  {
    id: "embargo1973",
    start: "1973-01", end: "1974-12",
    benchmark: "Arabian Light official/posted (est.)",
    verified: false,
    note: "OPEC raised posted price ~70% to $5.12 on 16 Oct 1973, then to $11.65 on 1 Jan 1974. Spot/auction cargoes briefly sold for $17+ in Dec 1973.",
    monthly: [
      2.59, 2.59, 2.59, 2.70, 2.75, 2.90, 2.95, 3.00, 3.01, 4.20, 5.12, 5.12, // 1973
      11.65, 11.65, 11.65, 11.65, 11.65, 11.65, 11.65, 11.65, 11.65, 11.65, 11.25, 11.25, // 1974
    ],
    dailyExtremes: [{ date: "1973-12-16", price: 17.04, note: "Iranian NIOC auction price (approx.)" }],
  },
  {
    id: "iran1979",
    start: "1979-01", end: "1980-12",
    benchmark: "Spot market (Arabian Light / Brent-type), est.",
    verified: false,
    note: "Iranian revolution cut exports; spot prices ran far above OPEC official prices. Iran-Iraq war (Sep 1980) caused a second leg up.",
    monthly: [
      16.0, 21.0, 22.0, 23.0, 32.0, 34.0, 33.0, 31.0, 35.0, 38.0, 40.0, 39.0, // 1979
      39.0, 37.0, 36.0, 35.5, 35.5, 35.0, 34.5, 33.0, 34.0, 38.0, 40.0, 39.0, // 1980
    ],
    dailyExtremes: [{ date: "1979-11-15", price: 41.0, note: "Approximate late-1979 spot peak" }],
  },
  {
    id: "crash1986",
    start: "1986-01", end: "1986-12",
    benchmark: "WTI Cushing spot (EIA RWTC)",
    verified: true,
    note: "Saudi Arabia abandoned its swing-producer role and flooded the market with netback-priced crude.",
    monthly: [22.93, 15.46, 12.61, 12.84, 15.38, 13.43, 11.59, 15.10, 14.87, 14.90, 15.22, 16.11],
    dailyExtremes: [{ date: "1986-03-31", price: 10.25, note: "WTI spot low (EIA daily)" }],
  },
  {
    id: "gulfwar1990",
    start: "1990-01", end: "1991-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "Iraq invaded Kuwait on 2 Aug 1990. Price collapsed on 17 Jan 1991 when Desert Storm began.",
    monthly: [
      21.25, 19.81, 18.39, 16.61, 16.35, 15.10, 17.17, 27.17, 34.90, 36.02, 33.07, 28.27, // 1990
      23.57, 19.54, 19.08, 19.18, 19.19, 18.17, 19.40, 19.77, 20.50, 22.21, 21.11, 18.41, // 1991
    ],
    dailyExtremes: [
      { date: "1990-09-27", price: 41.45, note: "Brent spot peak" },
      { date: "1991-01-17", price: 21.10, note: "Brent fell from 30.28 to 21.10 in one day as the air war began" },
    ],
  },
  {
    id: "low1998",
    start: "1998-01", end: "1998-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "Asian financial crisis plus extra OPEC supply.",
    monthly: [15.19, 14.07, 13.10, 13.53, 14.36, 12.21, 12.08, 11.91, 13.34, 12.70, 11.04, 9.82],
    dailyExtremes: [{ date: "1998-12-10", price: 9.10, note: "Brent spot low" }],
  },
  {
    id: "spike2008",
    start: "2008-01", end: "2008-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "Record spike, then the global financial crisis. NYMEX WTI traded as high as $147.27 intraday on 11 Jul 2008.",
    monthly: [92.18, 94.99, 103.64, 109.07, 122.80, 132.32, 132.72, 113.24, 97.23, 71.58, 52.45, 39.95],
    dailyExtremes: [
      { date: "2008-07-03", price: 143.95, note: "Brent spot record close" },
      { date: "2008-07-11", price: 147.27, note: "NYMEX WTI intraday all-time high" },
      { date: "2008-12-26", price: 33.73, note: "Brent spot low" },
    ],
  },
  {
    id: "shale2014",
    start: "2014-01", end: "2015-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "US shale glut; OPEC declined to cut on 27 Nov 2014. Bottomed at $26 in Jan 2016.",
    monthly: [
      108.12, 108.90, 107.48, 107.76, 109.54, 111.80, 106.77, 101.61, 97.09, 87.43, 79.44, 62.34, // 2014
      47.76, 58.10, 55.89, 59.52, 64.08, 61.48, 56.56, 46.52, 47.62, 48.43, 44.27, 38.01, // 2015
    ],
    dailyExtremes: [{ date: "2016-01-20", price: 26.01, note: "Brent spot low (just after this window)" }],
  },
  {
    id: "covid2020",
    start: "2020-01", end: "2020-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "COVID demand collapse plus the Saudi-Russia price war. Brent averaged ~$18 in April, but WTI front-month went negative for one day.",
    monthly: [63.65, 55.66, 32.01, 18.38, 29.38, 40.27, 43.24, 44.74, 40.91, 40.19, 42.69, 49.99],
    wtiMonthly: [57.52, 50.54, 29.21, 16.55, 28.56, 38.31, 40.71, 42.34, 39.63, 39.40, 40.94, 47.02],
    // One-day negative-price event for the game to trigger:
    negativePriceEvent: {
      date: "2020-04-20",
      price: -37.63, // NYMEX WTI May-2020 contract settlement (EIA Cushing spot printed -36.98)
      benchmark: "NYMEX WTI front-month",
      nextDay: 10.01, // May contract settled +$10.01 on 21 Apr (spot printed 8.91)
      note: "Storage at Cushing nearly full and the contract about to expire; holders paid buyers to take barrels.",
    },
    dailyExtremes: [{ date: "2020-04-21", price: 9.12, note: "Brent spot low" }],
  },
  {
    id: "ukraine2022",
    start: "2022-01", end: "2022-12",
    benchmark: "Brent spot (EIA RBRTE)",
    verified: true,
    note: "Russia invaded Ukraine on 24 Feb 2022.",
    monthly: [86.51, 97.13, 117.25, 104.58, 113.34, 122.71, 111.93, 100.45, 89.76, 93.33, 91.42, 80.92],
    dailyExtremes: [{ date: "2022-03-08", price: 133.18, note: "Brent spot peak" }],
  },
];
